export const Types = {
  REQUEST: '@newNotifications/REQUEST',
  UPDATE_NEW_NOTIFICATIONS: '@newNotifications/UPDATE_NEW_NOTIFICATIONS',
  SHOW_NOTIFICATIONS: '@newNotifications/SHOW_NOTIFICATIONS',
};

export function updateNewNotifications(value) {
  return {
    type: Types.UPDATE_NEW_NOTIFICATIONS,
    value,
  };
}

export function getNewNotifications() {
  return {
    type: Types.REQUEST,
  };
}

export function showNewNotifications(title, body) {
  return {
    type: Types.SHOW_NOTIFICATIONS,
    title,
    body,
  };
}
